<script setup>
import Header from '@/components/Header.vue'
import FooterIndex from '@/components/FooterIndex.vue'
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();

const showLayout = computed(() => {
  // 当路由元信息中明确设置 showLayout: false 时隐藏
  return route.meta.showLayout !== false;
});
</script>

<template>
  <div class="app-container">
    <Header v-if="showLayout"/>
    <main class="main-content">
      <router-view></router-view>
    </main>
    <footer-index v-if="showLayout"/>
  </div>
</template>

<style scoped>
.app-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.main-content {
  flex: 1 0 auto; /* 主要内容区域占据剩余空间 */
}
</style>
